import type { JSX } from 'react'
import { Avatar } from '@buffer-mono/popcorn'

import styles from './CollaboratorAvatars.module.css'

export function CollaboratorAvatars({
  avatar,
  username,
  collaborator,
}: {
  avatar: string
  username: string
  collaborator: string
}): JSX.Element {
  return (
    <div className={styles.stack}>
      <Avatar src={avatar || undefined} alt={username} size="xsmall" />
      <Avatar alt={collaborator} size="xsmall" />
    </div>
  )
}

export function collaboratorPreviewName(
  username: string,
  count: number,
): string {
  return count > 0
    ? `${username} and ${count} ${count === 1 ? 'other' : 'others'}`
    : username
}
